<template>
  <div class="bg-initial">
    <v-container fluid fill-height class="overlay">
      <v-row
        align="center"
        justify="center"
      >
        <v-col cols="12" class="login-card">
          <v-card
            class="mx-auto rounded-card-large"
            max-width="600"
          >
            <div class="d-flex justify-center">
              <div class="mt-12">
                <v-img class="logo"
                       width="300"
                       src="../../assets/logo-proxpect.svg"
                       alt="Logo da Proxpect"/>
              </div>
            </div>
            <v-card-text class="d-flex flex-column align-center mt-10">
              <div class="login-fields">
                <div class="error--text"
                     v-if="error"
                     align="center">
                  {{ error }}
                </div>
                <v-form
                  ref="form"
                >
                  <v-text-field
                    outlined
                    v-model="user"
                    :error="$v.user.$error"
                    @blur="$v.user.$touch()"
                    label="E-mail"
                    class="rounded-card-small"
                    required
                  />
                  <v-text-field
                    outlined
                    hide-details
                    v-model="password"
                    label="Senha"
                    type="password"
                    class="rounded-card-small mt-5"
                    :error="$v.password.$error"
                    @blur="$v.password.$touch()"
                    v-on:keyup.enter="doLogin"
                    required
                  />
                </v-form>
                <v-row dense no-gutters class="mt-2 text-right">
                  <v-col cols="12">
                    <px-dialog-esqueceu-senha/>
                  </v-col>
                </v-row>
                <v-row class="mt-5">
                  <v-col cols="12" class="text-right">
                    <v-btn outlined large
                           class="mr-2 normal-btn-text elevation-0 rounded-card-small"
                           :disabled="loading"
                           @click="goToCriarConta">
                      Criar conta
                    </v-btn>
                    <v-btn large
                           color="primary"
                           class="normal-btn-text elevation-0 rounded-card-small"
                           :disabled="$v.$invalid"
                           :loading="loading"
                           @click="doLogin">Entrar
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import EventService from '@/events';
import axios from '@/plugins/axios/axios-config';
import { FETCH_USER } from '@/store/user/actions.type';
import { LOGIN } from './store/actions.type';
import DialogEsqueceuSenha from './DialogEsqueceuSenha.vue';

export default {
  computed: {
    ...mapGetters('login', {
      loading: 'loading',
      error: 'error',
    }),
    ...mapGetters({
      redirect: 'redirect',
    }),
    ...mapGetters('user', { loggedUser: 'user', hasRoleMarketplace: 'hasRoleMarketplace' }),
    user: {
      get() {
        return this.$store.getters['login/user'];
      },
      set(user) {
        this.$store.dispatch('login/user', user);
      },
    },
    password: {
      get() {
        return this.$store.getters['login/password'];
      },
      set(password) {
        this.$store.dispatch('login/password', password);
      },
    },
  },
  methods: {
    ...mapActions('login', {
      logar: LOGIN,
    }),
    ...mapActions('user', {
      getUser: FETCH_USER,
    }),
    doLogin() {
      if (!this.user || !this.password) {
        return;
      }
      this.logar()
        .then(() => {
          EventService.createLogin(axios, null);
          return this.getUser()
            .then(() => {
              if (this.redirect) {
                this.$router.push(this.redirect);
                return;
              }
              if (this.hasRoleMarketplace) {
                this.$router.push({ name: 'main.indicadores-marketplace' });
                return;
              }
              this.$router.push({ name: 'main.meu-painel' });
            });
        });
    },
    goToCriarConta() {
      this.$router.push({ name: 'criar-conta' });
    },
  },
  components: {
    pxDialogEsqueceuSenha: DialogEsqueceuSenha,
  },
  validations: {
    user: {
      required,
    },
    password: {
      required,
    },
  },
};
</script>

<style scoped>
.bg-initial {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/capa-login.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  background-position: center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
}

.login-fields {
  width: 100%;
  max-width: 400px;
}
</style>
